<template>
    <MarkerContainer
        class="workloadRequirementMarker"
        :title="title"

        draggable="true"

        @dragstart="startDragging"
        @dragend="endDragging"
        @click:marker="openPublishPage"
    >
        <span :class="className">{{ amount }}</span>
    </MarkerContainer>
</template>

<script lang="ts">
    import {WrDragData, WorkloadRequirementAmount} from '@/types/types';
    import {Shift} from '@cquential/api';
    import MarkerContainer from '@/components/Planbord/MarkerContainer.vue';
    import {Component, Vue, Prop} from 'vue-facing-decorator';
    import RoosterplanningUrlBuilder from '@/util/RoosterplanningUrlBuilder';

    @Component({
        components: {
            MarkerContainer,
        },
    })
    export default class LegacyWorkloadRequirementCell extends Vue {
        @Prop({required: true}) public requirement!: WorkloadRequirementAmount;
        @Prop({required: true}) public shift!: Shift;
        @Prop({required: true}) public date!: Date;

        public get amount(): number {
            return (-this.requirement.required + this.requirement.count);
        }

        public get title(): string {
            return this.requirement.count.toFixed(0) + '/' + this.requirement.required.toFixed(0);
        }

        // Method to highlight shift requirement based on status
        public get className(): string {
            if (this.amount >= 0) {
                return 'requirementFulfilled';
            }

            return 'requirementNotFulfilled';
        }

        public get publishShiftLink(): string | undefined {
            if (this.amount >= 0) {
                return undefined;
            }

            return `${RoosterplanningUrlBuilder.getHostUrl()}?pageid=P_ROSTER_OPENSHIFT&rosterid=${this.shift.rosterId}&date=${(this.date.valueOf() / 1000).toFixed(0)}&shiftid=${this.shift.id}`;
        }

        public getTarget(event: DragEvent): HTMLElement | null {
            return event.target ? event.target as HTMLElement : null;
        }

        public endDragging(event: DragEvent): void {
            const eventTarget: HTMLElement | null = this.getTarget(event);

            // Make acton visible
            if (eventTarget) {
                eventTarget.style.opacity = '';
            }
            // Define dragImage at props point and remove from DOM
            const dragImage: HTMLElement | null = document.getElementById('dragImage');
            if (dragImage) {
                document.querySelector('#planbord')!.removeChild(dragImage);
            }
        }

        public startDragging(event: DragEvent): void {
            const eventTarget: HTMLElement | null = this.getTarget(event);

            // Make acton visible
            if (eventTarget) {
                eventTarget.style.opacity = '0.5';
            }
            // Create visible element when dragging
            const div: HTMLElement = document.createElement('div');
            div.id = 'dragImage';
            // we haven't made the styling for these things global... so I've to manually set the styling
            // props isn't the right way to do it
            // TODO figure out what the right way is (it works for now)
            div.style.fontWeight = '700';
            div.style.color = 'var(--theme-text-color)';
            div.style.border = '1px solid var(--deployment-marker-active-border-color)';
            div.style.borderRadius = '2px';
            div.style.background = 'var(--deployment-marker-default-background)';
            div.style.padding = '0 10px 0 3px';
            const span: HTMLElement = document.createElement('span');
            span.textContent = this.shift.template!.code;
            div.appendChild(span);
            // Append element to DOM temporarily
            document.querySelector('#planbord')!.appendChild(div);
            // Define data to drag
            const dataToDrag: WrDragData = {
                shiftId: this.shift.id,
                date: this.date,
                stateId: 1,
            };
            // Write data to dataTransfer
            if (event.dataTransfer) {
                if (typeof event.dataTransfer.setDragImage === 'function') {
                    event.dataTransfer.setDragImage(div, 15, 15);
                }
                event.dataTransfer.setData('text', JSON.stringify(dataToDrag));
            }
        }

        public openPublishPage(): void {
            if (this.publishShiftLink) {
                window.open(this.publishShiftLink, '_blank')?.focus();
            }
        }
    }
</script>

<style lang="scss" scoped>
    .workloadRequirementMarker {
        width: 3.6ch;
        text-align: center;
    }

    .requirementNotFulfilled {
        color: var(--cq-red);
        text-decoration: underline;
    }
</style>
